import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=72113ce8"
import script from "./read-more.vue?vue&type=script&lang=ts"
export * from "./read-more.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports